import React, { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

export const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({});
  const [persist, setPersist] = useState(
    JSON.parse(localStorage.getItem("persist")) || false
  );

  useEffect(() => {
    localStorage.setItem("persist", JSON.stringify(persist));
    const token = localStorage.getItem("tk");
    if (token) {
      const decoded = jwtDecode(token);
      setAuth({
        id: decoded.id,
        currentCar: decoded.currentCar,
        monitorBy: decoded.monitorBy,
        token: token,
        multipleCars: decoded.multipleCars,
        ndaAccepted: decoded.ndaAccepted,
        paymentWindow: decoded.paymentWindow,
        trialDays: decoded.trialDays,
        membershipAmount: decoded.membershipAmount,
        membership: decoded.membership,
      });
    }
  }, [persist]);

  return (
    <AuthContext.Provider value={{ auth, setAuth, persist, setPersist }}>
      {children}
    </AuthContext.Provider>
  );
};
